import React from "react";
import {
    Box,
    Card,
    CardContent,
    Container,
    Grid,
    Typography,
} from "@mui/material";
import { cardSx, sectionSubtitleSx, sectionTitleSx } from "./homeStyles";

import kaspiLogo from "../../img/banks/kaspi.png";
import halykLogo from "../../img/banks/halyk.png";
import alatauLogo from "../../img/banks/alatau.png";
import kaznaLogo from "../../img/banks/kazna.png";

const bankCards = [
    {
        name: "Kaspi Bank",
        logo: kaspiLogo,
    },
    {
        name: "Halyk Bank",
        logo: halykLogo,
    },
    {
        name: "Alatau Bank",
        logo: alatauLogo,
    },
    {
        name: "Kaznashylyk",
        logo: kaznaLogo,
    },    
];

function HomeBanks() {
    return (
        <Container maxWidth="xl" sx={{ py: { xs: 6, md: 8 } }}>
            <Box textAlign="center" sx={{ mb: { xs: 4, md: 5 } }}>
                <Typography variant="h3" sx={sectionTitleSx}>
                    С какими банками мы работаем
                </Typography>

                <Typography sx={sectionSubtitleSx}>
                    Поддерживаем обработку платежных поручений в форматах
                    подключенных банков.
                </Typography>
            </Box>

            <Grid container spacing={1.75} justifyContent="center">
                {bankCards.map((item) => (
                    <Grid
                        size={{ xs: 12, sm: 6, md: 4 }}
                        key={item.name}
                        sx={{ display: "flex" }}
                    >
                        <Card sx={{ ...cardSx, width: "100%" }}>
                            <CardContent
                                sx={{
                                    p: { xs: 1.5, md: 2 },
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    minHeight: { xs: 92, md: 108 },
                                }}
                            >
                                <Box
                                    component="img"
                                    src={item.logo}
                                    alt={item.name}
                                    sx={{
                                        width: "100%",
                                        maxWidth: 220,
                                        height: "auto",
                                        objectFit: "contain",
                                        display: "block",
                                    }}
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
}

export default HomeBanks;